import { render, staticRenderFns } from "./RoomCheckMark.vue?vue&type=template&id=05a880c3&scoped=true&"
import script from "./RoomCheckMark.vue?vue&type=script&lang=js&"
export * from "./RoomCheckMark.vue?vue&type=script&lang=js&"
import style0 from "./RoomCheckMark.vue?vue&type=style&index=0&id=05a880c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a880c3",
  null
  
)

export default component.exports